import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/auth'

/**
 * Wraps routes that require authentication.
 * Unauthenticated users are redirected to /login with the attempted path preserved.
 */
export default function ProtectedRoute() {
  const { accessToken } = useAuthStore()
  const location = useLocation()

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
